import React from 'react';

interface IconProps {
  viewBox?: string;
  size?: string | number;
  height?: string | number;
  width?: string | number;
  fill?: string;
  fillOpacity?: string | number;
  otherProps?: Record<string, unknown>;
  children?: React.ReactNode;
  className?: string;
  style?: Record<string, unknown>;
}

const Icon = (props: IconProps) => {
  let { viewBox, width, height } = props;
  const {
    size = 24,
    fill = 'none',
    className,
    style,
    otherProps,
    children,
  } = props;
  width = width ? width : size;
  height = height ? height : size;
  viewBox = viewBox ? viewBox : `0 0 ${width} ${height}`;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      className={`fill-current ${className}`}
      style={style}
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
};

export type IconType = typeof Icon;

export const BadgeIcon = (props: IconProps) => {
  return (
    <Icon fill="#E77635" viewBox="0 0 10 20" width={10} height={20} {...props}>
      <path d="M10 8.43V0H0V8.43C0 8.78 0.18 9.11 0.49 9.29L4.67 11.8L3.68 14.14L0.27 14.43L2.86 16.67L2.07 20L5 18.23L7.93 20L7.15 16.67L9.74 14.43L6.33 14.14L5.34 11.8L9.52 9.29C9.82 9.11 10 8.79 10 8.43ZM6 10.23L5 10.83L4 10.23V1H6V10.23Z" />
    </Icon>
  );
};

export const DoctorHatIcon = (props: IconProps) => {
  return (
    <Icon
      fill="black"
      fill-opacity="0.85"
      viewBox="0 0 22 18"
      width={24}
      height={24}
      {...props}
    >
      <path d="M11 0L0 6L4 8.18V14.18L11 18L18 14.18V8.18L20 7.09V14H22V6L11 0ZM17.82 6L11 9.72L4.18 6L11 2.28L17.82 6ZM16 12.99L11 15.72L6 12.99V9.27L11 12L16 9.27V12.99Z" />
    </Icon>
  );
};

export const WorkCardIcon = (props: IconProps) => {
  return (
    <Icon
      fill="black"
      fillOpacity={0.85}
      viewBox="0 0 18 20"
      width={18}
      height={20}
      {...props}
    >
      <path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM9 6C10.66 6 12 7.34 12 9C12 10.66 10.66 12 9 12C7.34 12 6 10.66 6 9C6 7.34 7.34 6 9 6ZM15 18H3V16.6C3 14.6 7 13.5 9 13.5C11 13.5 15 14.6 15 16.6V18Z" />
    </Icon>
  );
};

export const TimedIcon = (props: IconProps) => {
  return (
    <Icon
      fill="black"
      fillOpacity="0.85"
      viewBox="0 0 21 20"
      width={21}
      height={20}
      {...props}
    >
      <path d="M14.5 9.5H13V13.5L16 15.5L16.75 14.27L14.5 12.75V9.5ZM14 6L0 0V7L9 9L0 11V18L7.27 14.89C8.09 17.83 10.79 20 14 20C17.86 20 21 16.86 21 13C21 9.14 17.86 6 14 6ZM14 18C11.25 18 9.02 15.78 9 13.03V12.96C9.02 10.22 11.25 7.99 14 7.99C16.76 7.99 19 10.23 19 12.99C19 15.75 16.76 18 14 18Z" />
    </Icon>
  );
};

export const WandIcon = (props: IconProps) => {
  return (
    <Icon fill="black" width="24" height="24" {...props}>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.38477 5.44727C8.50195 5.44727 8.56055 5.37891 8.58008 5.26172C8.89258 3.76758 8.87305 3.71875 10.4453 3.40625C10.5527 3.38672 10.6309 3.31836 10.6309 3.20117C10.6309 3.09375 10.5527 3.02539 10.4453 3.00586C8.87305 2.68359 8.89258 2.63477 8.58008 1.14062C8.56055 1.0332 8.50195 0.955078 8.38477 0.955078C8.26758 0.955078 8.19922 1.0332 8.17969 1.14062C7.86719 2.64453 7.89648 2.69336 6.32422 3.00586C6.2168 3.02539 6.13867 3.09375 6.13867 3.20117C6.13867 3.31836 6.20703 3.38672 6.32422 3.40625C7.89648 3.72852 7.87695 3.77734 8.17969 5.27148C8.19922 5.37891 8.26758 5.44727 8.38477 5.44727ZM16.1094 8.71875C16.2461 8.71875 16.3242 8.63086 16.3438 8.49414C16.6758 6.73633 16.6758 6.62891 18.541 6.30664C18.6777 6.28711 18.7656 6.19922 18.7656 6.0625C18.7656 5.92578 18.6777 5.84766 18.541 5.81836C16.6758 5.49609 16.6562 5.38867 16.3438 3.63086C16.3242 3.50391 16.2461 3.40625 16.1094 3.40625C15.9727 3.40625 15.8848 3.50391 15.8652 3.63086C15.5527 5.39844 15.543 5.50586 13.6777 5.81836C13.541 5.83789 13.4531 5.92578 13.4531 6.0625C13.4531 6.19922 13.541 6.28711 13.6777 6.30664C15.543 6.62891 15.5527 6.73633 15.8652 8.50391C15.8848 8.63086 15.9727 8.71875 16.1094 8.71875ZM3.30664 11.4141C3.44336 11.4141 3.53125 11.3164 3.55078 11.1895C3.86328 9.42188 3.88281 9.31445 5.74805 8.99219C5.875 8.97266 5.97266 8.88477 5.97266 8.74805C5.97266 8.61133 5.875 8.5332 5.74805 8.51367C3.87305 8.18164 3.86328 8.08398 3.55078 6.31641C3.53125 6.18945 3.44336 6.0918 3.30664 6.0918C3.17969 6.0918 3.0918 6.18945 3.07227 6.31641C2.75977 8.08398 2.75 8.19141 0.875 8.51367C0.748047 8.5332 0.650391 8.61133 0.650391 8.74805C0.650391 8.88477 0.748047 8.97266 0.875 8.99219C2.75 9.32422 2.75 9.42188 3.07227 11.1895C3.0918 11.3164 3.17969 11.4141 3.30664 11.4141ZM19.0977 19.3145C19.5078 19.7344 20.2109 19.7344 20.6016 19.3145C21.0117 18.8848 21.0117 18.2305 20.6016 17.8105L11.832 9.00195C11.4219 8.58203 10.709 8.58203 10.3184 9.00195C9.91797 9.43164 9.91797 10.0957 10.3184 10.5059L19.0977 19.3145ZM13.7852 12.957L11.0508 10.2129C10.875 10.0469 10.8262 9.85156 10.9922 9.67578C11.1582 9.5293 11.3535 9.55859 11.5293 9.74414L14.2637 12.4785L13.7852 12.957ZM7.7207 19.5C7.89648 19.5 8.02344 19.373 8.04297 19.1777C8.3457 16.707 8.46289 16.6387 10.9824 16.2383C11.1973 16.1992 11.3145 16.0918 11.3145 15.9062C11.3145 15.7305 11.1973 15.6133 11.0215 15.5742C8.48242 15.0957 8.3457 15.1055 8.04297 12.6348C8.02344 12.4395 7.89648 12.3125 7.7207 12.3125C7.54492 12.3125 7.41797 12.4395 7.38867 12.625C7.07617 15.1348 6.97852 15.2227 4.41992 15.5742C4.24414 15.6035 4.11719 15.7305 4.11719 15.9062C4.11719 16.082 4.24414 16.1992 4.41016 16.2383C6.97852 16.7266 7.06641 16.7266 7.38867 19.1973C7.41797 19.373 7.54492 19.5 7.7207 19.5Z"
          fill="#D33030"
        />
      </svg>
    </Icon>
  );
};

export const LightBulbIcon = (props: IconProps) => {
  return (
    <Icon fill="black" width="24" height="24" {...props}>
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.00016 12.9987C3.00016 13.3654 3.30016 13.6654 3.66683 13.6654H6.3335C6.70016 13.6654 7.00016 13.3654 7.00016 12.9987V12.332H3.00016V12.9987ZM5.00016 0.332031C2.42683 0.332031 0.333496 2.42536 0.333496 4.9987C0.333496 6.58536 1.12683 7.9787 2.3335 8.82537V10.332C2.3335 10.6987 2.6335 10.9987 3.00016 10.9987H7.00016C7.36683 10.9987 7.66683 10.6987 7.66683 10.332V8.82537C8.8735 7.9787 9.66683 6.58536 9.66683 4.9987C9.66683 2.42536 7.5735 0.332031 5.00016 0.332031ZM6.3335 8.13203V9.66537H3.66683V8.13203C2.6535 7.4187 1.66683 6.68536 1.66683 4.9987C1.66683 3.1587 3.16016 1.66536 5.00016 1.66536C6.84016 1.66536 8.3335 3.1587 8.3335 4.9987C8.3335 6.6587 7.32683 7.43203 6.3335 8.13203Z"
          fill="#323232"
        />
      </svg>
    </Icon>
  );
};
